import { ComboboxOptions as HeadlessComboboxOptions } from '@headlessui/react';

type ComboboxOptionsProperties = {
  readonly isOpen: boolean;
  readonly children: { options: JSX.Element; addOption: JSX.Element };
  readonly dataTestIdPrefix?: string;
};

export function ComboboxOptions({
  isOpen,
  children,
  dataTestIdPrefix,
}: ComboboxOptionsProperties) {
  if (!isOpen) {
    return null;
  }
  return (
    <HeadlessComboboxOptions
      data-testid={(dataTestIdPrefix ?? '') + 'combobox-options'}
      static={isOpen}
      className="absolute mt-1 z-[var(--z-index-dropdown)] w-full rounded-xl py-3 px-4 bg-white text-base drop-shadow-md border-blue-50 border focus:outline-none"
    >
      <div className="relative w-full h-full">
        <div className="overflow-auto max-h-21rem">{children.options}</div>
      </div>
      {children.addOption}
    </HeadlessComboboxOptions>
  );
}
